import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import SystemInfo from "../../../util/SystemInfo";
import { FaEllipsisV, FaEye, FaEdit, FaTrash } from "react-icons/fa";

const ProductObservationsActionDropdown = ({ value, onDelete }) => {
    const { user, permissions, isSuperAdmin } = useAuth();
    const navigate = useNavigate();

    const systemCode = SystemInfo?.systemCode || 'sys-002';

    // Verificar si es propietario de la observación
    const isOwner =
        (value?.user_id && Number(value?.user_id) === Number(user?.id)) ||
        (value?.created_by && Number(value?.created_by) === Number(user?.id)) ||
        (value?.user?.id && Number(value?.user?.id) === Number(user?.id)) ||
        (value?.createdBy?.id && Number(value?.createdBy?.id) === Number(user?.id));

    // Permiso de editar: SuperAdmin, permiso global sys-002-update-observations, o propietario
    const canEdit = isSuperAdmin || permissions?.includes(`${systemCode}-update-observations`) || isOwner;

    // Permiso de eliminar: SuperAdmin, permiso global sys-002-delete-observations, o propietario
    const canDelete = isSuperAdmin || permissions?.includes(`${systemCode}-delete-observations`) || isOwner;

    return (
        <Dropdown className="dropdown ms-auto text-end">
            <Dropdown.Toggle
                variant=""
                className="btn-link i-false text-muted p-1 border-0 shadow-none"
                data-toggle="dropdown"
                style={{ cursor: 'pointer' }}
            >
                <FaEllipsisV size={16} />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-right shadow-sm border-0 py-1" style={{ minWidth: '150px' }}>
                <Dropdown.Item
                    onClick={() => navigate(`/observaciones/${value?.id}`)}
                    className="d-flex align-items-center gap-2 py-2"
                >
                    <FaEye className="text-info" /> <span>Ver Detalles</span>
                </Dropdown.Item>

                {canEdit && (
                    <Dropdown.Item
                        onClick={() => navigate(`/observaciones/editar/${value?.id}`)}
                        className="d-flex align-items-center gap-2 py-2"
                    >
                        <FaEdit className="text-warning" /> <span>Editar</span>
                    </Dropdown.Item>
                )}

                {canDelete && (
                    <Dropdown.Item
                        onClick={() => onDelete?.(value)}
                        className="d-flex align-items-center gap-2 py-2 text-danger"
                    >
                        <FaTrash /> <span>Eliminar</span>
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ProductObservationsActionDropdown;
